import { inject, Injectable } from '@angular/core';
import { IBlackListByIdResponse, IBlackListCreateRequest, IBlackListEditRequest, IBlackListHistoricoParams, IBlackListQueryParams, IBlackListResponse } from './IBlackList';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';
import { buildQueryParams } from 'src/app/core/utils/builder-query-params';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class BlackListService {
  http = inject(HttpClient);
  endpoint = 'BlackListControlle';

  public GetBlackLists(
    params: IBlackListQueryParams
  ): Observable<IBlackListResponse> {
    const url = `${environment.baseURL}${this.endpoint}/GetBlackLists`;

    return this.http.get<IBlackListResponse>(url, {
      params: buildQueryParams(params)
    });
  }

  public GetBlackListHistorico(
    params: IBlackListHistoricoParams
  ): Observable<IBlackListResponse> {
    const url = `${environment.baseURL}${this.endpoint}/GetBlackListHistorico`;

    return this.http.get<IBlackListResponse>(url, {
      params: buildQueryParams(params)
    });
  }

  public GetBlackListById(id: number): Observable<IBlackListByIdResponse> {
    const url = `${environment.baseURL}${this.endpoint}/GetBlackListById?id=${id}`;

    return this.http.get<IBlackListByIdResponse>(url);
  }
  public PatchBlackListDesbloquear(
    id: string
  ): Observable<IBlackListByIdResponse> {
    const url = `${environment.baseURL}${this.endpoint}/PatchBlackListDesbloquear?PK_BLCK_LIST=${id}`;

    return this.http.patch<IBlackListByIdResponse>(url, { id });
  }

  public CreateBlackList(
    body: IBlackListCreateRequest
  ): Observable<IBlackListResponse> {
    const url = `${environment.baseURL}${this.endpoint}/CreateBlackList`;
    return this.http.post<IBlackListResponse>(url, body);
  }

  public UpdateBlackList(
    body: IBlackListEditRequest
  ): Observable<IBlackListResponse> {
    const url = `${environment.baseURL}${this.endpoint}/UpdateBlackList`;
    return this.http.put<IBlackListResponse>(url, body);
  }
}
